import React from 'react';
import { Box, Card, Skeleton } from '@mui/material';
import ArgonBox from '../ArgonBox';

const HonorariosSkeleton = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
        paddingBottom: "100px",
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}
    >
      {/* Header skeleton */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "400px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "40px",
          marginTop: "20px",
          position: "relative",
        }}
      >
        <Skeleton
          variant="text"
          width={150}
          height={40}
          sx={{
            backgroundColor: '#f0f0f0',
            borderRadius: '8px'
          }}
        />
        <Skeleton
          variant="circular"
          width={32}
          height={32}
          sx={{
            backgroundColor: '#f0f0f0',
            position: 'absolute',
            right: 0,
            top: 0
          }}
        />
      </Box>

      {/* Contenedor centrado para la card */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: "-95px"
        }}
      >
        {/* Card principal skeleton */}
        <Card sx={{ 
          width: '100%', 
          maxWidth: 400, 
          borderRadius: '16px', 
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#ffffff',
          position: 'relative'
        }}>
          <ArgonBox p={4}>
            {/* Header con título skeleton */}
            <ArgonBox display="flex" justifyContent="center" alignItems="center" mb={2} position="relative">
              <Skeleton
                variant="text"
                width={200}
                height={30}
                sx={{
                  backgroundColor: '#f0f0f0',
                  borderRadius: '8px'
                }}
              />
              <Skeleton
                variant="circular"
                width={32}
                height={32}
                sx={{
                  backgroundColor: '#f0f0f0',
                  position: 'absolute',
                  right: 0,
                  top: 0
                }}
              />
            </ArgonBox>

            {/* Descripción skeleton */}
            <Skeleton
              variant="text"
              width="100%"
              height={20}
              sx={{
                backgroundColor: '#f0f0f0',
                borderRadius: '8px',
                marginBottom: '24px'
              }}
            />

            {/* Controles de precio skeleton */}
            <ArgonBox 
              display="flex" 
              alignItems="center" 
              justifyContent="center" 
              gap={3} 
              mb={4}
            >
              {/* Botón menos skeleton */}
              <Skeleton
                variant="circular"
                width={40}
                height={40}
                sx={{
                  backgroundColor: '#f0f0f0'
                }}
              />
              
              {/* Precio central skeleton */}
              <ArgonBox display="flex" flexDirection="column" alignItems="center">
                <Skeleton
                  variant="text"
                  width={80}
                  height={40}
                  sx={{
                    backgroundColor: '#f0f0f0',
                    borderRadius: '8px',
                    marginBottom: '4px'
                  }}
                />
                <Skeleton
                  variant="text"
                  width={100}
                  height={16}
                  sx={{
                    backgroundColor: '#f0f0f0',
                    borderRadius: '8px'
                  }}
                />
              </ArgonBox>
              
              {/* Botón más skeleton */}
              <Skeleton
                variant="circular"
                width={40}
                height={40}
                sx={{
                  backgroundColor: '#f0f0f0'
                }}
              />
            </ArgonBox>

            {/* Botón Guardar skeleton */}
            <Skeleton
              variant="rectangular"
              width="100%"
              height={56}
              sx={{
                backgroundColor: '#f0f0f0',
                borderRadius: '12px'
              }}
            />
          </ArgonBox>
        </Card>
      </Box>
    </Box>
  );
};

export default HonorariosSkeleton;
